jQuery(document).ready(function(){
    // Move all video modals to just before </body> so they escape
    // any stacking context created by parent sections.
    $('.video-modal-overlay').each(function() {
        const $modal = $(this);
        // Store a reference on the trigger button so we can find the modal after it moves
        const modalId = $modal.attr('id');
        if (modalId) {
            $modal.siblings('[onclick*="openVideoModal"]').attr('data-video-modal', modalId);
        }
        $modal.appendTo('body');
    });
});


window.openVideoModal = function(btn) {
    // First try the data attribute (for modals that were relocated to body)
    const modalId = $(btn).attr('data-video-modal');
    let closestVideoModal;

    if (modalId) {
        closestVideoModal = document.getElementById(modalId);
    } else {
        // Fallback: try sibling lookup (in case modal wasn't moved)
        closestVideoModal = $(btn).siblings('.video-modal-overlay')[0];
    }

    if (!closestVideoModal) return;

    $(closestVideoModal).addClass('active');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
}

window.closeVideoModal = function(event, videoID) {
    // If clicking overlay background (not the modal box itself), close
    if (event && event.target !== document.getElementById(`video-modal-${videoID}`)) return;

    $(`#video-modal-${videoID} iframe`).attr("src", $(`#video-modal-${videoID} iframe`).attr("src"));
    document.querySelector(`#video-modal-${videoID} video`)?.pause();
    $('.video-modal-overlay').removeClass('active');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
}

// Also allow ESC key to close
document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
        closeVideoModal();
    }
});
